module.exports = __webpack_public_path__ + "static/assets/aa5e1a2ea01301cb280d194cf72bac3f.png";